import { a as clientConfigs, m as mobileScreenSize } from '../configs-1fb8eed2.js';
import useWindowSize from './useWindowSize.js';
import 'react';
import './useDebounce.js';

function useDeviceType(screenType) {
  const {
    width
  } = useWindowSize();
  const type = screenType || (clientConfigs.isMobile ? clientConfigs.isMobile() ? 'mobile' : 'desktop' : width < mobileScreenSize ? 'mobile' : 'desktop');
  return {
    type,
    isMobile: type === 'mobile'
  };
}

export { useDeviceType as default };
